import { LDP_OPTIONS } from "../types/LandingPageOption";

export const MAPPING_NAME: Record<LDP_OPTIONS, string> = {
  [LDP_OPTIONS.O1]: "Option 1",
  [LDP_OPTIONS.O2]: "Option 2",
  [LDP_OPTIONS.O3]: "Option 3",
};
